module.exports = __webpack_public_path__ + "img/logo-republic.2858b22c.svg";